import core from "@/core";

class Nav {
  items = [
    {
      _name: "CSidebarNav",
      _children: [
        {
          _name: "CSidebarNavTitle",
          _children: ["병해충 영상진단"],
        },
        {
          _name: "CSidebarNavItem",
          name: "토마토",
          to: "/analysis/disease/tomato",
          fontIcon: "flaticon flaticon-tomato-o flaticon-fw nav-font-icon"
        },
        {
          _name: "CSidebarNavItem",
          name: "딸기",
          to: "/analysis/disease/strawberry",
          fontIcon: "flaticon flaticon-strawberry-o flaticon-fw nav-font-icon"
        },
        {
          _name: "CSidebarNavItem",
          name: "파프리카",
          to: "/analysis/disease/paprika",
          fontIcon: "flaticon flaticon-capsicum-o flaticon-fw nav-font-icon"
        },
        {
          _name: "CSidebarNavItem",
          name: "로봇방제시스템",
          to: "/analysis/disease/robot",
          fontIcon: "fa fa-android",
        },
        {
          _name: "CSidebarNavTitle",
          _children: ["병해충 분석요청"],
        },
        {
          _name: "CSidebarNavItem",
          name: "병해충 분석요청",
          to: "/analysis/disease/request",
          icon: "cil-comment-bubble",
        },
      ],
    },
  ];

  getNavList() {
    return this.items;
  }
}

export default new Nav();
